import * as React from 'react';
import AntRadio, { RadioProps as AntRadioProps } from 'antd/lib/radio';
import RadioGroup from 'antd/lib/radio/group';
import RadioButton from 'antd/lib/radio/radioButton';

import styles from './Radio.module.scss';
export interface RadioProps extends AntRadioProps {}

export class Radio extends React.Component<RadioProps, {}> {
	static Group: typeof RadioGroup;
	static Button: typeof RadioButton;

	render() {
		return <AntRadio className={styles.radio} {...this.props} />;
	}
}

Radio.Group = AntRadio.Group;
Radio.Button = AntRadio.Button;

export default Radio;
